const GROWTH_REACTIVATE_MY_MEMBERSHIP_PRODUCT_CAROUSEL = {
  EXPERIMENT_NAME: 'growth-reactivate-my-membership-product-carousel_1.0.0',
  CONTROL: 'control',
  VARIATION_ON: 'on',
  FEATURE_FLAG: 'growth-reactivate-my-membership-product-carousel',
};

export { GROWTH_REACTIVATE_MY_MEMBERSHIP_PRODUCT_CAROUSEL };
